import { StyledP } from './Paragraph.styles';

const Paragraph = ({ children, ...rest }) => {
  return <StyledP {...rest}>{children}</StyledP>;
};

export default Paragraph;
